/*
 * Common functionality across the sites for marketing services
 */

var MarketingTracking = {
	/*
	 * Get the reference list for a specific event type
	 *
	 * @param {string} eventType - The name of the event type
	 *
	 * @return {object} - A reference list of the event type
	 */
	getEventType: function (eventType) {
		eventType = eventType || '';
		eventType = eventType.toLowerCase();

		var events = this.getEventTypes();

		if(events.hasOwnProperty(eventType)) {
			return events[eventType];
		}

		return {};
	},


	/*
	 * Get the reference list for the available event types
	 *
	 * @return {object} - A reference list of the available event types
	 */
	getEventTypes: function () {
		return {
			aw: {
				name: 'Google AdWords',
				callback: 'gtag'
			},
			ga: {
				name: 'Google Analytics',
				callback: 'ga'
			},
			gtm: {
				name: 'Google Tag Manager',
				callback: 'gtag'
			},
			gts: {
				name: 'Google Certified Shops',
				callback: 'gts'
			},
			pixel: {
				name: 'Facebook Pixel',
				callback: 'fbq'
			}
		};
	},


	/*
	 * Track an event for a specific marketing service.
	 * Select an appropriate tracking handler based on the event type
	 *
	 * @param {string} eventType - The name of the event type
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	track: function (eventType) {
		if (typeof eventType !== 'string' || eventType === '') {
			return false;
		}

		// Use the lower-case name of the event type
		eventType = eventType.toLowerCase();

		if(!Object.keys(this.getEventType(eventType)).length) {
			return false;
		}

		// Set callback name and arguments
		var callback = '_track' + eventType[0].toUpperCase() + eventType.slice(1),
				args = Array.prototype.slice.call(arguments, 1);

		if(this.hasOwnProperty(callback)) {
			this[callback].apply(this, args);
		}
	},


	/*
	 * Parse the conversion rate value using comma to separate decimals
	 *
	 * @private {function}
	 *
	 * @param {float|integer} value - The conversion rate value
	 *
	 * @return {float|integer} - The parsed conversion rate value. Default set to 0
	 */
	_parseConversionRate: function (value) {
		value = value || 0;
		value = value.toString().replace(',', '.');
		value = parseFloat(value);
		value = !isNaN(value) ? value : 0;

		return value;
	},


	/*
	 * Track a standard or custom event with Facebook Pixel
	 *
	 * @private {function}
	 *
	 * @param {string} eventName - The event name
	 * @param {object} options - A list of keys and values consisting of parameters in the tracking data
	 * @param {boolean} custom - A flag to track a custom event used to define custom audiences for ad optimization
	 *
	 * @see Reference on Facebook Pixel - https://developers.facebook.com/docs/facebook-pixel/reference
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_trackPixel: function (eventName, options, custom) {
		options = options || {};
		custom = custom || false;

		if (typeof options !== 'object') {
			return false;
		}

		if (typeof fbq === 'undefined') {
			return false;
		}

		var eventType = 'track',
				data = {
					currency: window.fbPixelEvents.currency,
					utm: window.fbPixelEvents.utmData
				};

		if (custom === true) {
			eventType = 'trackCustom';
		}

		// Update values using the custom options
		$.extend(data, options);

		// Normalize conversion rate values
		data.value = this._parseConversionRate(data.value);

		// Trigger the FB Pixel event
		fbq(eventType, eventName, data);
	},


	/*
	 * Track a standard or custom event with Google AdWords
	 *
	 * @private {function}
	 *
	 * @param {string} eventName - The event name
	 * @param {object} options - A list of keys and values consisting of parameters in the tracking data
	 */
	_trackAw: function (eventName, options) {
	},


	/*
	 * Track a standard or custom event with Google Analytics
	 *
	 * @private {function}
	 *
	 * @param {string} eventName - The event name
	 * @param {object} options - A list of keys and values consisting of parameters in the tracking data
	 */
	_trackGa: function (eventName, options) {
	},


	/*
	 * Track a standard or custom event with Google Tag Manager
	 *
	 * @private {function}
	 *
	 * @param {string} eventName - The event name
	 * @param {object} options - A list of keys and values consisting of parameters in the tracking data
	 */
	_trackGtm: function (eventName, options) {
	},


	/*
	 * Track a standard or custom event with Google Certified Shops
	 *
	 * @private {function}
	 *
	 * @param {string} eventName - The event name
	 * @param {object} options - A list of keys and values consisting of parameters in the tracking data
	 */
	_trackGts: function (eventName, options) {
	}
};


var MarketingEvents = {
	/*
	 * Manage the tracking event handlers when the DOM is fully loaded.
	 * Initialize all event handlers based on the handler callback
	 */
	handle: function () {
		var self = this;

		// Initialize all event handlers
		Object.keys(self).forEach(function (callback) {
			if(callback.search('_handle') === 0) {
				self[callback].apply(self);
			}
		});
	},


	/*
	 * Trigger a tracking event.
	 * Select an appropriate callback based on the event name
	 *
	 * @param {string} eventName - The event name
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	trigger: function (eventName) {
		if (typeof eventName !== 'string' || eventName === '') {
			return false;
		}

		// Set callback name and arguments
		var callback = '_trigger' + eventName,
				args = Array.prototype.slice.call(arguments, 1);

		// Trigger a custom callback event
		if(this.hasOwnProperty(callback)) {
			this[callback].apply(this, args);
		}
	},


	/*
	 * Manage the "Lead" event.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_handleLead: function () {
		var $button = $('.js-lead-hero-button');

		if (!$button.length) {
			return false;
		}

		$button.on('click', function (event) {
			var $self = $(this),
					category = $self.data('gacategory'),
					label = $self.data('galabel'),
					customerType = $self.data('customer-type');

			// Trigger FB Pixel event
			MarketingTracking.track('pixel', 'Lead', {
				content_name: label,
				content_category: category,
				customer_type: customerType
			});
		});
	},


	/*
	 * Manage the "ViewContent" event.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_handleViewContent: function () {
		if (typeof fbq !== 'undefined') {
			if (typeof window.fbPixelEvents.content !== 'undefined') {
				var content = window.fbPixelEvents.content,
						contentType = content.contentType || 'page';

				// Do not track "ViewContent" event on search results page
				if (contentType === 'search') {
					return false;
				}

				// Trigger FB Pixel event
				MarketingTracking.track('pixel', 'ViewContent', {
					content_name: content.name,
					content_category: content.category,
					content_type: contentType
				});
			}
		}
	},


	/*
	 * Manage the "AddToBasket" event.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_handleAddToBasket: function () {
		var $form = $('.js-add-to-basket-form');

		if (!$form.length) {
			return false;
		}

		var $button = $('.js-add-to-basket-button'),
				product = $form.data('product-details'),
				self = this;

		// Trigger FB Pixel event
		MarketingTracking.track('pixel', 'ViewContent', {
			content_name: product.name,
			content_ids: [product.code],
			content_category: product.category,
			content_type: 'product',
			value: product.value,
			value_type: product.valueType
		});

		// Manage form data before submit
		$button.on('click', function (event) {
			if (!validateOptions('basket')) {
				return false;
			}

			self.trigger('AddToBasket', $form, product);
			splitEventTrigger('user','addtoBasket', 1);
		});
	},


	/*
	 * Manage the "AddToBasket" event for recommended products.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_handleAddRecommendedToBasket: function () {
		var $forms = $('.js-add-recommended-to-basket-form');

		if (!$forms.length) {
			return false;
		}

		var self = this;

		$forms.each(function (index, element) {
			$(element).on('submit', function (event) {
				var $form = $(element),
						product = $form.data('product-details');

				if (!validateOptions('basket')) {
					event.preventDefault();

					return false;
				}

				self.trigger('AddToBasket', $form, product);
			});
		});
	},


	/*
	 * Manage the "Search" event.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_handleSearch: function () {
		// TODO: Remove "doSearch" function and add the "Search" event triggers to this handler
		// TODO: Move "Search" event triggers form "createSearchAutocomplete" function to this handler
	},


	/*
	 * Manage the "SignIn" event.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_handleSignedIn: function () {
		if (typeof fbq !== 'undefined') {
			if (window.fbPixelEvents.customerState == 1) {
				// Trigger FB Pixel event
				MarketingTracking.track('pixel', 'SignIn', {
					assert: window.fbPixelEvents.defaults.yes
				}, true);
			}
		}
	},


	/*
	 * Manage the "Purchase" event.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_handlePurchase: function () {
		if (typeof fbq !== 'undefined') {
			if (typeof window.fbPixelEvents.purchase !== 'undefined') {
				var purchase = window.fbPixelEvents.purchase;

				// Trigger FB Pixel event
				MarketingTracking.track('pixel', 'Purchase', {
					content_name: purchase.name,
					content_ids: purchase.ids,
					content_category: purchase.category,
					content_type: window.fbPixelEvents.customerType,
					num_items: purchase.total,
					value: purchase.value
				});
			}
		}
	},


	/*
	 * Manage the "AutoReorder" event.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_handleAutoReorder: function () {
		if (typeof fbq !== 'undefined') {
			if (typeof window.fbPixelEvents.autoReorder !== 'undefined') {
				var autoReorder = window.fbPixelEvents.autoReorder;

				// Trigger FB Pixel event for an active Auto Re-Order
				if (autoReorder.panel === 1 || autoReorder.panel === true) {
					var key = autoReorder.status === 1 ? 'yes' : 'no';

					// Trigger FB Pixel event
					MarketingTracking.track('pixel', 'AutoReorder', {
						reorder_id: autoReorder.id,
						assert: window.fbPixelEvents.defaults[key]
					}, true);
				}
			}
		}
	},


	/*
	 * Trigger the "AddToBasket" event.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @param {object} form - A DOM reference for a HTML form
	 * @param {object} product - A list of keys and values for the product details
	 * 		key {string} name - The product name
	 * 		key {string} code - The product code
	 * 		key {string} brand - The product brand
	 * 		key {string} category - The product category
	 * 		key {string} price - The regular price of the product
	 * 		key {string} value - The current price of the product
	 * 		key {string} valueType - The type of discount applied on the product
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_triggerAddToBasket: function (form, product) {
		// Trigger FB Pixel event
		MarketingTracking.track('pixel', 'AddToCart', {
			content_name: product.name,
			content_ids: [product.code],
			content_category: product.category,
			content_type: 'product',
			value: product.value,
			value_type: product.valueType
		});

		// Trigger GA event
		gaForAddToBasket(product.code, product.name, product.price, true, product.category, product.brand);
		gvUpdateBasketFromFormData(form);

		// Go through the accessories and fire it based on those
		$('input[name^=accessories]:checked').each(function (key,value) {
			gaForAddToBasket(value.dataset.code, value.dataset.name, value.dataset.price, false, value.dataset.category, value.dataset.brand);
			gvFireAddToShoppingCartAction(value.dataset.gvproductid, 1);
		});
	},


	/*
	 * Trigger the "InitiateCheckout" event.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_triggerInitiateCheckout: function () {
		if (typeof fbq !== 'undefined') {
			if (typeof window.fbPixelEvents.initialCheckout !== 'undefined') {
				var checkout = window.fbPixelEvents.initialCheckout;

				// Trigger FB Pixel event
				MarketingTracking.track('pixel', 'InitiateCheckout', {
					content_name: checkout.name,
					content_ids: checkout.ids,
					content_category: checkout.category,
					num_items: checkout.total,
					value: checkout.value
				});
			}
		}
	},


	/*
	 * Trigger the "CompleteRegistration" event.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_triggerCompleteRegistration: function () {
		if (typeof fbq !== 'undefined') {
			// Trigger FB Pixel event
			MarketingTracking.track('pixel', 'CompleteRegistration', {
				assert: window.fbPixelEvents.defaults.yes
			});
		}
	},


	/*
	 * Trigger the "Search" event.
	 * Track the event for multiple marketing services
	 *
	 * @private {function}
	 *
	 * @param {string} value - The search term
	 * @param {string} action - The type of action performed on the search form
	 * 		search - The user submitted the search query
	 * 		select - The user selected an item from the search autocomplete list
	 *
	 * @return {boolean} - Used only as control value to interrupt script execution
	 */
	_triggerSearch: function (value, action) {
		var options = {
			content_category: 'Header search'
		};

		// Set the value and action used for the search
		options.search_string = value;
		options.search_action = action;

		// Trigger FB Pixel event
		MarketingTracking.track('pixel', 'Search', options);
	}
};
